import React from "react";
import { lang } from "../../i18nLang";
import { Button, TextField, styled, Typography, Grid } from "@material-ui/core";
import { Title1 } from "../UI/Typographies";
import PasswordField from "../UI/Fields/PasswordField";

const ButtonLogin = styled(Button)(({ theme }) => ({
  display: "block",
  margin: "0 auto",
  marginTop: theme.spacing(6),
}));

type IProps = {
  onSubmit: Function;
};

class RegisterForm extends React.Component<IProps> {
  state = {
    name: "",
    email: "",
    password: "",
  };

  handleChangeInputs = (ev) => {
    const value = ev.target.value;
    const name = ev.target.name;

    const newState = { ...this.state };
    newState[name] = value;
    this.setState(newState);
  };

  handleSubmit = async (ev) => {
    ev.preventDefault();
    await this.props.onSubmit({
      name: this.state.name,
      email: this.state.email,
      password: this.state.password,
    });
  };

  render() {
    const disableLogin =
      this.state.name.length === 0 ||
      this.state.email.length === 0 ||
      this.state.password.length === 0;
    return (
      <form onSubmit={this.handleSubmit}>
        <Title1>{lang("login.register.title")}</Title1>
        <Typography style={{ marginBottom: "1rem" }}>
          {lang("login.register.text")}
        </Typography>
        <TextField
          id="txtName"
          label={lang("name")}
          name="name"
          inputProps={{
            maxLength: "30",
          }}
          fullWidth
          onChange={this.handleChangeInputs}
          value={this.state.name}
          margin="normal"
        />
        <Grid container spacing={2}>
          <Grid item xs>
            <TextField
              id="txtEmail"
              label="E-mail"
              name="email"
              fullWidth
              onChange={this.handleChangeInputs}
              value={this.state.email}
              margin="normal"
            />
          </Grid>
          <Grid item xs>
            <PasswordField
              id="txtPassword"
              label={lang("password")}
              name="password"
              value={this.state.password}
              onChange={this.handleChangeInputs}
              fullWidth
              margin="normal"
            />
          </Grid>
        </Grid>

        <ButtonLogin
          type="submit"
          color="primary"
          variant="contained"
          disabled={disableLogin}
        >
          {lang("login.register.createAccount")}
        </ButtonLogin>
      </form>
    );
  }
}

export default RegisterForm;
